import { BaseFormEntityRequest } from './BaseFormEntityRequest';

export class FormEpcBiblioCorrectionRequest extends BaseFormEntityRequest {
  id?: number;
  faculty: string;
  requiredDate: Date;
  archiveIds: string;
  reasonCode: number;
}
